module.exports = __webpack_public_path__ + "img/phrea.f86bc4ef.gif";